import { DxSingleSelect, DxSingleSelectItem } from '@dvag/design-system-react';
import i18next from 'i18next';
import { guardianSelectTypes } from 'service/model/consentType';

interface LegalGuardianSelectProps {
  value: string;
  onChange: (value: string) => void;
  isSubmitting: boolean;
  isConsentFetching: boolean;
  readMode: boolean;
}

export const LegalGuardianSelect = ({
  value,
  onChange,
  isSubmitting,
  isConsentFetching,
  readMode,
}: LegalGuardianSelectProps) => {
  return (
    <DxSingleSelect
      size="m"
      columns={2}
      value={value}
      disabled={isSubmitting || isConsentFetching || readMode}
      onValueChange={(e) => onChange(e.detail)}
      data-testid="guardian-single-select"
      id="guardian-single-select"
      label={i18next.t('sendConsent.consentOrLegalGuardianModal.legalGuardianSelection.label')}
    >
      <DxSingleSelectItem
        value={guardianSelectTypes.HOUSEHOLD_MEMBER}
        data-testid="guardian-household-member"
        id="guardian-household-member"
        disabled={isSubmitting}
        label={i18next.t(
          'sendConsent.consentOrLegalGuardianModal.legalGuardianSelection.householdMember',
        )}
      />
      <DxSingleSelectItem
        value={guardianSelectTypes.OTHER_PERSON}
        data-testid="guardian-other-person"
        id="guardian-other-person"
        disabled={isSubmitting || isConsentFetching}
        label={i18next.t(
          'sendConsent.consentOrLegalGuardianModal.legalGuardianSelection.otherPerson',
        )}
      />
    </DxSingleSelect>
  );
};
